// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3bzDq","inner":"style_inner__14xZs","bottom":"style_bottom__m8e_C","footerContent":"style_footerContent__DRKGK"};